"use client";

import type { AccommodationFacilityType } from "../../../__generated__/gql/graphql";
import { useInNativeApp } from "../../_hooks/use-in-native-app";
import { CtaButton } from "../room-detail/content/cta-button";

import { buildReserveUrl } from "./_utils/build-reserve-url";

export type ReservationCtaProps = {
  /** エリアの slug。 CTA URL の area パラメータに使う。 */
  areaSlug: string;
  /** エリアの表示名。 サブラベル「{areaName}エリアの拠点」に埋め込む。 */
  areaName: string;
  /**
   * 建築タイプ (seriesShortName) の union。
   * 拠点ページは site 配下の全 architectureType、部屋タイプページは単数、エリアページは未指定。
   */
  archValues?: readonly string[];
  /**
   * 施設タイプの union。
   * 拠点ページは site の facilityTypes、それ以外は未指定。
   */
  facilityTypes?: readonly AccommodationFacilityType[];
};

/**
 * エリア / 拠点 / 部屋タイプページの末尾に置く予約導線 CTA。
 *
 * - SANU アプリ内は非表示 (`useInNativeApp === true`)
 * - SSR 初期 (`undefined`) も非表示 (ちらつき防止)
 * - WEB (`false`) の場合のみ描画
 *
 * 遷移先は `/go/reserve?area=...&arch=...&facility-filter=...`。
 * 会員 / Stay 判定と実際の予約カレンダーへの redirect は `/go/reserve` が担う。
 */
export function ReservationCta({
  areaSlug,
  areaName,
  archValues,
  facilityTypes,
}: ReservationCtaProps) {
  const isInNativeApp = useInNativeApp();

  if (isInNativeApp !== false) return null;

  const href = buildReserveUrl({ areaSlug, archValues, facilityTypes });

  return (
    <CtaButton
      action={{
        kind: "navigate-with-icon",
        href,
        label: "予約する",
        subLabel: `${areaName}エリアの拠点`,
      }}
    />
  );
}
